import React from "react";
import { useNavigate } from "react-router-dom";

import styles from "../components/utilities/cssmodules/NotFound.module.css";



const NotFound = () => {
    const navigate = useNavigate(); // Initialize the useNavigate in the constant "navigate"
    const handleGoback = () => {
        navigate(-1); // Go back to the previous page
    };


    return (  
        <div className="component-wrapper">
            {/* <div className="component-title">Not Found</div> */}

            <div className="wrapper">
                <div className={styles.not_found_component_container}>
                <div className={styles.not_found_component_heading_text}>4&#123;/&#125;4</div>
                <div className={styles.not_found_component_description_text}>The page you're looking for was not found</div>
                <div className={styles.not_found_component_routing_text}><button className="secondary-button" onClick={handleGoback}>Go back</button></div>
                </div>
            </div>
        </div>
    );
}
 
export default NotFound;